/**
 * Mémorisation du choix de portions pour la session de cuisine en cours
 * (US-07 : « mémorisé pour la session de cuisine en cours mais ne modifie pas
 * la recette enregistrée »). `sessionStorage` plutôt que `localStorage` :
 * c'est bien la session en cours qui doit se souvenir du choix, pas
 * indéfiniment sur l'appareil. Accès protégé — un navigateur en navigation
 * privée stricte peut refuser `sessionStorage` ; la mémorisation est un
 * confort, pas une exigence bloquante, donc l'échec est silencieux.
 *
 * Module partagé entre `RecipeDetail.tsx` (le sélecteur de portions
 * souhaitées, US-07, qui écrit cette clé) et `CookMode.tsx` (US-08, qui la
 * relit pour afficher des quantités déjà adaptées en mode cuisine) — même clé
 * pour les deux, pas de second mécanisme de mémorisation (cf. DECISIONS.md,
 * « US-07 » : « conçue dès maintenant pour qu'US-08 puisse la relire telle
 * quelle »).
 */
export function targetServingsStorageKey(recipeId: string): string {
  return `mlc:portions-cibles:${recipeId}`;
}

export function readStoredTargetServings(recipeId: string): number | null {
  try {
    const raw = sessionStorage.getItem(targetServingsStorageKey(recipeId));
    if (raw === null) return null;
    const value = Number(raw);
    return Number.isFinite(value) && value > 0 ? value : null;
  } catch {
    return null;
  }
}

export function writeStoredTargetServings(recipeId: string, value: number | null): void {
  try {
    const key = targetServingsStorageKey(recipeId);
    if (value === null) sessionStorage.removeItem(key);
    else sessionStorage.setItem(key, String(value));
  } catch {
    // Mémorisation en confort : une écriture refusée ne doit pas casser l'écran.
  }
}
